var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcontoolbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 68,
    viewBox: "0 0 72 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0921 17.773V20.7352H71.0913V23.5674H71.1028V62.0756C71.1028 65.333 68.4359 67.9999 65.1785 67.9999H62.2163V38.3782L59.2541 32.4539L56.2928 38.3782V67.9999H42.9571V51.1184C46.4515 49.4484 48.8815 45.9144 48.8815 41.7857C48.8815 37.6579 46.4515 34.1231 42.9571 32.4539V41.7857C42.9571 44.2393 40.9734 46.229 38.5198 46.229C36.0671 46.229 34.0765 44.2393 34.0765 41.7857V32.4539C30.5813 34.1231 28.1514 37.6579 28.1514 41.7857C28.1514 45.9144 30.5813 49.4484 34.0765 51.1184V67.9999H17.7787L17.7812 50.2269L20.7426 44.3026L17.7787 32.4539H11.856L8.89725 44.3026L11.8577 50.2269V67.9999H5.93508C2.67686 67.9999 0.0107422 65.333 0.0107422 62.0756V25.5105V23.5674V20.7352H0V17.773C0 14.5156 2.66612 11.8487 5.92434 11.8495H20.7352V5.92434C20.7352 2.65263 23.3878 0 26.6595 0H44.4325C47.7043 0 50.3569 2.65263 50.3569 5.9235V11.8487H65.1677C68.4251 11.8487 71.0921 14.5156 71.0921 17.773ZM7.35206 20.7352V23.5674H63.75V20.7352H7.35206ZM44.4325 5.92434H26.6595V11.8495H44.4325V5.92434Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcontoolbox);
export default __webpack_public_path__ + "static/media/icontoolbox.c4f9453e77d952767972951424cf5605.svg";
export { ForwardRef as ReactComponent };